import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-content gutter-y-s3" }
const _hoisted_2 = { class: "text-muted" }
const _hoisted_3 = { class: "flex dialog-detail align-items-center justify-content-between" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "dialog-footer dialog-footer-two-btn" }

import Spinner from '@/components/Spinner.vue';
import { useI18n } from 'vue-i18n';
import BluesTokenIcon from '@/components/token/BluesTokenIcon.vue';
import { printUSD } from '@/utils/format';


export default /*#__PURE__*/_defineComponent({
  __name: 'Confirmation',
  props: {
    amount: null,
    amountUsd: null,
    inProgress: { type: Boolean },
    cancel: null,
    confirm: null
  },
  setup(__props: any) {


const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('yieldPool.autoBounty.confirmDialog.youClaim')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BluesTokenIcon, {
          size: "20",
          full: ""
        }),
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(__props.amount), 1),
          _createElementVNode("span", _hoisted_4, " / " + _toDisplayString(_unref(printUSD)(__props.amountUsd)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        class: "button-base",
        label: _ctx.$t('cancel'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.cancel()))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "button-primary",
        label: _unref(t)('yieldPool.autoBounty.confirmDialog.confirmBtn'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.confirm())),
        disabled: __props.inProgress
      }, {
        default: _withCtx(() => [
          (__props.inProgress)
            ? (_openBlock(), _createBlock(Spinner, {
                key: 0,
                color: "white",
                size: "24",
                class: "mr-s2"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(t)('yieldPool.autoBounty.confirmDialog.confirmBtn')), 1)
        ]),
        _: 1
      }, 8, ["label", "disabled"])
    ])
  ], 64))
}
}

})